var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7075 4.56466C14.5464 3.94878 14.072 3.46372 13.4697 3.29911C12.3779 3 8 3 8 3C8 3 3.6221 3 2.53029 3.29911C1.92795 3.46375 1.45356 3.94878 1.29254 4.56466C1 5.68099 1 8.0101 1 8.0101C1 8.0101 1 10.3392 1.29254 11.4555C1.45356 12.0714 1.92795 12.5363 2.53029 12.7009C3.6221 13 8 13 8 13C8 13 12.3779 13 13.4697 12.7009C14.072 12.5363 14.5464 12.0714 14.7075 11.4555C15 10.3392 15 8.0101 15 8.0101C15 8.0101 15 5.68099 14.7075 4.56466ZM6.56817 10.1248V5.89544L10.2272 8.01016L6.56817 10.1248Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.579176d43f4543aca565438de11f5289.svg";
export { ForwardRef as ReactComponent };